import React from 'react';
import type { ServiceCreateModalWithoutProjectContext as ServiceCreateModalWithProjectContextType } from '@atlassian/jira-spa-apps-servicedesk-service-create-modal-without-project-context/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServiceCreateModalWithProjectContext = lazyForPaint<
	typeof ServiceCreateModalWithProjectContextType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-service-create-modal-without-project-context", jiraSpaEntry: "async-servicedesk-service-create-modal-without-project-context" */ '@atlassian/jira-spa-apps-servicedesk-service-create-modal-without-project-context'
		),
);

const AsyncServiceCreateModalWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceCreateModalWithProjectContext}
		pageId="spa-apps/servicedesk/service-create-modal"
		shouldShowSpinner
	/>
);

export default AsyncServiceCreateModalWithProjectContext;
